export const getProjectGroupingKey = (orgId: string | null, teamId: string | null) =>
  `${orgId}:${teamId}:project-grouping`;
export const getProjectGroupLabelKey = (orgId: string | null, teamId: string | null) =>
  `${orgId}:${teamId}:project-group-label`;
export const getProjectGroupKey = (orgId: string | null, teamId: string | null) =>
  `${orgId}:${teamId}:project-group-key`;

// Defers grouping redirects so an in-flight router action (e.g. login → /files,
// modal close via router.back()) can settle before the next replace fires.
export const GROUPING_REDIRECT_DELAY_MS = 100;
